import {
  ASPECT_RATIO,
  ASPECT_RATIO_POW,
  gridPhotos
} from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '2 - 3x5, 4 - 2x3',
  imageCount: 6,
  displayGroup: 'DG_3X5_WALLET',
  calc: (height) => {
    const prWidth = height / (ASPECT_RATIO_POW + 2);
    const prHeight = prWidth * ASPECT_RATIO;
    const pWidth = prHeight;
    const pHeight = pWidth * ASPECT_RATIO;

    return {
      gridTemplate: `
        'p1 p2' ${prWidth}px
        'p3 p4' ${prWidth}px
        'p5 p6' ${pHeight}px
        / ${prHeight}px ${prHeight}px`,
      photos: [...gridPhotos(1, 4, prWidth, prHeight, 90), ...gridPhotos(5, 6, pWidth, pHeight)]
    };
  }
};
